import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { transferOrganizationOwnership } from ".";

export function useTransferOrganizationOwnership(){
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.organisation._def,
        mutationFn: transferOrganizationOwnership,
        onSuccess: ()=>{
            queryClient.invalidateQueries({queryKey: queryKeys.organisation._def, exact: false});
        }
    })
}
